import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import CloseIcon from "assets/icons/close-big.svg?react";

import BinIcon from "assets/icons/bin.svg?react";
import prettyBytes from "pretty-bytes";

import AttachmentIconComponent from "components/AttachmentIconComponent";
import { useEffect, useRef, useState } from "react";
import { LinearProgress, Tooltip } from "@mui/material";
import DotsIcon from "assets/icons/three-dots.svg?react";
import SignIcon from "assets/icons/sign.svg?react";
import XadesIcon from "assets/icons/add_new.svg?react";
import classNames from "classnames";
import { default as Dropdown2 } from "components/OptionsCard/Dropdown";
import { Option } from "components/OptionsCard/typings";
import DropdownMui from "components/DropdownMui";
import { IDropdownObject } from "components/Dropdown/typings";
import { useTranslation } from "react-i18next";

const CreateOutgoingParcelFile: FC<Props> = ({
  file,
  handleRemove,
  onClick,
  index,
  actualFile,
  actualProgress,
  isSelected = false,
  hasError = false,
  errorMessage = null,
  large = false,
  handleSign,
  courtPortalTypes,
  handleAttachmentTypeChanged,
  initialAttachmentType,
}) => {
  const { t } = useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);
  const [options, setOptions] = useState<Option[]>([]);

  const [isSigned, setIsSigned] = useState<boolean>(!!file.xades);
  const [type, setType] = useState<string>(
    courtPortalTypes != null &&
      (initialAttachmentType ??
        (courtPortalTypes.length
          ? index === 0
            ? courtPortalTypes[0].type
            : courtPortalTypes[1].type
          : null)),
  );

  const refWrapper = useRef();

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleAddXades = () => {
    if (fileInputRef) {
      fileInputRef.current.click();
    }
  };

  const onDrop = async () => {
    setIsSigned(true);
  };

  useEffect(() => {
    const opt = [
      {
        name: t("edelivery.sign"),
        Icon: SignIcon,
        callback: () => {
          handleSign(index);
        },
        additional: true,
        isEnabled: true,
        canMultiple: true,
      },
      {
        name: t("documents.addXades"),
        Icon: XadesIcon,
        callback: () => {
          handleAddXades();
        },
        additional: true,
        isEnabled: true,
        canMultiple: true,
      },
      {
        name: t("common.delete"),
        Icon: BinIcon,
        callback: () => {
          handleRemove(index);
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
      },
    ];

    // if (participant.HasConflict) {
    //   opt = [
    //     {
    //       name: "Powiąż dane podmiotu",
    //       Icon: ArrowsIcon,
    //       callback: () => {
    //         setShowResolveConflict(true);
    //       },
    //       additional: false,
    //       isEnabled: true,
    //       canMultiple: true,
    //     },
    //     ...opt,
    //   ];
    // }

    // if (group == null || group === CaseParticipantGroup.Normal) {
    //   opt.push({
    //     name: 'Przenieś do "Dw"',
    //     Icon: MoveIcon,
    //     callback: () => {
    //       onMove(participant, true);
    //     },
    //     additional: false,
    //     isEnabled: true,
    //     canMultiple: true,
    //   });
    // }

    setOptions(opt);
  }, []);

  useEffect(() => {
    if (file.xades) {
      setIsSigned(true);
    }
  }, [file.xades]);

  const onTypeChanged = (value: IDropdownObject) => {
    setType(value.value as string);
    handleAttachmentTypeChanged(index, value.value as string);
  };

  return (
    <div
      className={`${styles.box} ${isSelected && styles.active} ${
        hasError && styles.error
      } ${large && styles.large}`}
      onClick={(e) => {
        if (e.target.type === "file") {
          e.stopPropagation();
          return;
        }

        console.log("Target", e.target);

        onClick();
      }}
      title={errorMessage}
    >
      <div className={styles.wrapper}>
        <AttachmentIconComponent file={file.name} />
        <div className={styles.information}>
          <div className={styles.name}>{file?.name}</div>
          {large && (
            <div className={styles.type}>
              <DropdownMui
                labelPosition="none"
                list={courtPortalTypes.map((x) => ({
                  name: x.description,
                  value: x.type,
                }))}
                defaultValue={type}
                allowNull={false}
                onChange={onTypeChanged}
                variant="standard"
                placeholder={t("common.type")}
                hideBorder={true}
              ></DropdownMui>
            </div>
          )}
          <div className={styles.size}>{prettyBytes(file.size ?? 0)}</div>
        </div>

        {isSigned && <SignIcon></SignIcon>}

        {!large && (
          <Tooltip title={t("common.delete")}>
            <div>
              <CloseIcon
                className={styles.icon}
                onClick={(e) => {
                  handleRemove(index);
                  e.stopPropagation();
                }}
              />
            </div>
          </Tooltip>
        )}

        {large && (
          <div className={styles.more} ref={refWrapper}>
            <Tooltip title={t("common.more")}>
              <div>
                <DotsIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setShowDropdown(!showDropdown);
                  }}
                  className={classNames(styles.icon)}
                />
              </div>
            </Tooltip>
            <Dropdown2
              toggle={() => setShowDropdown(false)}
              options={options}
              refWrapper={refWrapper}
              rightSide={false}
              scrollWrapper={undefined}
              showOptions={showDropdown}
              selectedElements={[]}
            />
          </div>
        )}

        <div className={styles.hidden}>
          <input
            ref={fileInputRef}
            type="file"
            onChange={() => onDrop()}
            multiple
          />
        </div>
      </div>
      {actualFile === index && !!actualProgress && (
        <div className={styles.progressBar}>
          <LinearProgress
            color="primary"
            variant={actualProgress !== -1 ? "determinate" : "indeterminate"}
            value={actualProgress}
          />
        </div>
      )}
    </div>
  );
};

export default CreateOutgoingParcelFile;
